// 데모용 플레이스홀더 사진 — 외부 의존 없이 SVG data URI 색 타일(실사진 대체 픽스처)
// UI 표준 갤러리·에이전트 컴포넌트 갤러리가 함께 쓴다.
const TILE_COLORS = ['#cdb9a3', '#a8bcc9', '#bcc9a8', '#c9a8b6', '#a3b0cd', '#c9c1a8', '#a8c9c0', '#c0a8c9']; // dq-ignore: data URI 사진 픽스처 — CSS 변수가 닿지 않는 이미지 바이트(UiStandardPage 에서 이관)

export function tile(color: string): string {
  return (
    'data:image/svg+xml,' +
    encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' width='160' height='120'><rect width='160' height='120' fill='${color}'/></svg>`)
  );
}

export const DEMO_TILES = TILE_COLORS.map((c, i) => ({ id: i + 1, url: tile(c), alt: `데모 사진 ${i + 1}` }));
